import { render, staticRenderFns } from "./advice.vue?vue&type=template&id=38784060&scoped=true&"
import script from "./advice.vue?vue&type=script&lang=js&"
export * from "./advice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38784060",
  null
  
)

export default component.exports